import React from 'react';
import { History, Trash2, ArrowUpRight, Trash, Clock } from 'lucide-react';
import Button from '../../../../../components/ui/Button';

/**
 * Компонент боковой панели истории конвертаций
 */
const HistorySidebar = ({ 
  historyItems, 
  loadFromHistory, 
  deleteHistoryItem, 
  clearHistory 
}) => {
  // Если нет истории, показываем пустое состояние
  if (!historyItems || historyItems.length === 0) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center gap-2">
          <History className="w-5 h-5 text-cyan-500" />
          История конвертаций
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Здесь будет отображаться история ваших конвертаций.
        </p>
      </div>
    );
  }

  // Функция для форматирования времени
  const formatTime = (timestamp) => {
    const date = new Date(parseInt(timestamp, 10) * 1000);
    return date.toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white flex items-center gap-2">
          <History className="w-5 h-5 text-cyan-500" />
          История конвертаций
        </h3>
        <Button
          size="sm"
          variant="ghost"
          onClick={clearHistory}
          icon={<Trash className="w-4 h-4 text-red-500" />}
          title="Очистить всю историю"
        >
          Очистить
        </Button>
      </div>

      <div className="space-y-3 max-h-96 overflow-y-auto pr-1 history-table">
        {historyItems.map((item) => (
          <div 
            key={item.id} 
            className="group bg-gray-50 dark:bg-gray-700/30 border border-gray-200 dark:border-gray-700 rounded-lg p-3 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <div className="flex justify-between items-start mb-1">
              <div className="font-mono text-sm text-cyan-600 dark:text-cyan-400">
                {item.timestamp}
              </div>
              <div className="flex items-center space-x-1 opacity-0 group-hover:opacity-100 transition-opacity">
                <button
                  type="button"
                  onClick={() => loadFromHistory(item.id)}
                  className="text-cyan-600 dark:text-cyan-400 hover:text-cyan-800 dark:hover:text-cyan-300 transition-colors p-1"
                  title="Использовать"
                >
                  <ArrowUpRight className="w-4 h-4" />
                </button>
                <button
                  type="button"
                  onClick={() => deleteHistoryItem(item.id)}
                  className="text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300 transition-colors p-1"
                  title="Удалить"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
            <div className="text-sm text-gray-800 dark:text-gray-200">
              {formatTime(item.timestamp)}
            </div>
            <div className="text-xs text-gray-500 dark:text-gray-400 flex items-center mt-1">
              <Clock className="w-3 h-3 mr-1" />
              <span>
                {new Date(item.date).toLocaleString('ru-RU', {
                  day: '2-digit',
                  month: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </span>
              <span className="mx-1">•</span>
              <span>{item.timezone?.replace('_', ' ') || 'UTC'}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HistorySidebar;